import { useEffect, useMemo, useState, useContext, useRef } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

// MindPlus components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// NewProduct page components
import FormField from "components/FormField";
import { Card } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { DataContext } from "context/dataContext";

function BreatheInfo() {
  const navigate = useNavigate();
  const params = useParams();

  const imageRef = useRef();
  const soundRef = useRef();

  const { dataState, getSingleBreatheApi, updateBreatheApi } = useContext(DataContext);

  const [editorValue, setEditorValue] = useState(
    "<p>Some initial <strong>bold</strong> text</p><br><br><br><br>"
  );
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [inhale, setInhale] = useState(0);
  const [exhale, setExhale] = useState(0);
  const [hold, setHold] = useState(0);
  const [category, setCategory] = useState("Focus");
  const [duration, setDuration] = useState("");
  const [tags, setTags] = useState([]);
  const [excerpt, setExcerpt] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState("Nature");
  const [price, setPrice] = useState(0);
  const [is_enable, setIsEnable] = useState("");

  const [image, setImage] = useState(null);
  const [files, setFiles] = useState([]);
  const [audiofile, setAudioFile] = useState(null);
  const [playerfile, setPlayerFile] = useState(null);

  const convertToSlug = (str) => {
    //replace all special characters | symbols with a space
    str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ").toLowerCase();

    // trim spaces at start and end of string
    str = str.replace(/^\s+|\s+$/gm, "");

    // replace space with dash/hyphen
    str = str.replace(/\s+/g, "-");

    return str;
  };

  const handleNameChange = (e) => {
    // var productName = e.target.value;
    // productName = productName.replace(/^\s+|\s+$/gm, "");

    setName(e.target.value);
    var slug = convertToSlug(e.target.value);

    setSlug(slug);
  };

  const handleInhaleChange = (e) => {
    setInhale(e.target.value);
  };

  const handleExhaleChange = (e) => {
    setExhale(e.target.value);
  };

  const handleHoldChange = (e) => {
    setHold(e.target.value);
  };

  const handelDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleExcerpt = (e) => {
    setExcerpt(e.target.value);
  };

  const handleCategory = (event, value) => {
    setCategory(value);
  };

  const handleTags = (event, value) => {
    setTags(value);
  };

  const handleType = (event, value) => {
    setType(value);
  };

  const handelActive = (event, value) => {
    setIsEnable(value);
  };

  const handlePrice = (e) => {
    setPrice(e.target.value);
  };

  const handleSave = () => {
    // navigate to add sessions page

    var breathe_id = params.id;

    // uploadProgramImageApi({
    //   id: sleep_id,
    //   image: files,
    // }).then((res) => {
    //   //console.log("getSingleBreatheApi", res);
    //   if (res.success) {
    //     console.log("Image Uploaded");
    //   } else {
    //     console.log("Something went wrong");
    //   }
    // });

    const form = new FormData();
    form.append("id", breathe_id);
    form.append("program", breathe_id);
    form.append("name", name);
    form.append("inhale", inhale);
    form.append("exhale", exhale);
    form.append("hold", hold);
    form.append("type", type);
    form.append("slug", slug);
    form.append("category", category);
    form.append("excerpt", excerpt);
    form.append("description", description);
    form.append("tags", tags);
    form.append("is_enable", is_enable);
    if (typeof image !== "string") {
      form.append("image", image);
    } else {
      form.append("image", null);
    }
    form.append("image", image);
    form.append("created_on", new Date());
    // form = {
    //   id: sleep_id,
    //   name: name,
    //   type: type,
    //   slug: slug,
    //   category: category,
    //   description: description,
    //   tags: tags,
    //   sessions: [],
    //   is_enable: is_enable,
    //   image: image,
    //   created_on: new Date(),
    // };

    updateBreatheApi({
      form: form,
    }).then((res) => {
      if (res.success) {
        console.log("Breathe Program Updated", res);
      } else {
        console.log("Something went wrong");
      }
    });
  };

  useEffect(() => {
    console.log(params);
    getSingleBreatheApi(params.id).then((res) => {
      console.log("getSingleBreatheApi", res);

      if (res.success) {
        let resData = res?.data?.data.breatheprogram;
        //console.log("getSingleBreatheApi resData", resData);
        setName(resData.name);
        setSlug(resData.slug);
        setInhale(resData.inhale);
        setExhale(resData.exhale);
        setHold(resData.hold);
        setDuration(resData.duration);
        setExcerpt(resData.excerpt);
        setCategory(resData.category);
        if (resData.tags) {
          var gottags = resData.tags.split(",");
          for (var i = 0; i < gottags.length; i++) {
            gottags[i] = gottags[i].replace(/^\s*/, "").replace(/\s*$/, "");
          }
          setTags(gottags);
        }
        setType(resData.type);
        setIsEnable(resData.is_enable);
        setDescription(resData.description);
        setImage(resData.image);
        setFiles(resData.image);
      } else {
        console.log("Something went wrong");
      }
    });
  }, []);

  const readImage = (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      // The file content is available in event.target.result
      const fileContent = event.target.result;
      console.log("File content:");
      setFiles(fileContent);
    };

    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };

    // Choose the appropriate reading method based on the file type and desired output:
    // reader.readAsText(file); // Reads the file as a plain text string
    reader.readAsDataURL(file); // Reads the file as a data URL (useful for images)
    // reader.readAsArrayBuffer(file); // Reads the file as an ArrayBuffer
    // reader.readAsText(file); // Example: reading as text
  };

  const handleImage = (e) => {
    console.log("file", e.target.files[0]);
    setImage(e.target.files[0]);
    var file = e.target.files[0];
    console.log(file);
    if (file) {
      // Proceed to read the file
      readImage(file);
    }
  };

  const setPlaceholderImage = () => {
    setImage("https://placehold.co/400x300");
  };

  return (
    <MDBox mt={3}>
      <Grid container spacing={3} pt={3}>
        <Grid item xs={12} sm={4}>
          <Card sx={{ overflow: "visible", p: 2 }}>
            <MDBox>
              <MDTypography variant="h5">Image</MDTypography>
              <MDBox mt={3}>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Breathe Image *
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDBox
                    component="img"
                    src={files}
                    alt={"Breathe Image"}
                    onError={setPlaceholderImage}
                    borderRadius="lg"
                    shadow="md"
                    width="100%"
                    height="100%"
                    position="relative"
                    zIndex={1}
                  />
                  <MDInput
                    type="file"
                    label="Image File"
                    variant="standard"
                    fullWidth
                    ref={imageRef}
                    onChange={handleImage}
                  />
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>

        <Grid item xs={12} sm={8} pt={7}>
          <Card sx={{ overflow: "visible", p: 2 }}>
            <MDTypography variant="h5">Breathe Infromation</MDTypography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormField type="text" label="Name *" value={name} onChange={handleNameChange} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormField type="text" disabled label="Slug" value={slug} />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormField
                  type="number"
                  label="Inhale (sec)"
                  value={inhale}
                  onChange={handleInhaleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField
                  type="number"
                  label="Hold (sec)"
                  value={hold}
                  onChange={handleHoldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormField
                  type="number"
                  label="Exhale (sec)"
                  value={exhale}
                  onChange={handleExhaleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={3}>
                  <MDBox mb={2} display="inline-block">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      textTransform="capitalize"
                    >
                      Category *
                    </MDTypography>
                  </MDBox>
                  <Autocomplete
                    value={category}
                    onChange={handleCategory}
                    options={["Focus", "Relaxation", "Balance", "Sleep"]}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={3}>
                  <MDBox mb={2} display="inline-block">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      textTransform="capitalize"
                    >
                      Tags *
                    </MDTypography>
                  </MDBox>
                  <Autocomplete
                    multiple
                    value={tags}
                    onChange={handleTags}
                    options={["Focus", "Relaxation", "Balance", "Sleep"]}
                    renderInput={(params) => <MDInput {...params} variant="standard" />}
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Description&nbsp;&nbsp;
                    <MDTypography variant="caption" color="text">
                      (optional)
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <FormField
                  type="text"
                  multiline
                  value={description}
                  onChange={handelDescription}
                  label="Enter description here"
                />
                {/* <MDEditor value={editorValue} onChange={setEditorValue} /> */}
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    Excerpt&nbsp;&nbsp;
                    <MDTypography variant="caption" color="text">
                      (*)
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <FormField
                  type="text"
                  multiline
                  value={excerpt}
                  onChange={handleExcerpt}
                  label="Enter excerpt here"
                />
                {/* <MDEditor value={editorValue} onChange={setEditorValue} /> */}
              </Grid>

              <Grid item xs={6} sm={3}>
                <MDBox mb={2} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    textTransform="capitalize"
                  >
                    Type *
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  defaultValue="Free"
                  options={["Free", "Premium", "Demo"]}
                  onChange={handleType}
                  renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
                {type === "Premium" ? (
                  <Grid item xs={12} sm={12} mt={2}>
                    <FormField type="text" label="Price" value={price} onChange={handlePrice} />
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
              <Grid item xs={6} sm={3}>
                <MDBox mb={2} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    textTransform="capitalize"
                  >
                    Active *
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  defaultValue="Active"
                  onChange={handelActive}
                  options={["Active", "Disabled"]}
                  renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} mt={2}>
              <MDButton mt={4} variant="gradient" color="primary" onClick={handleSave}>
                Save
              </MDButton>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default BreatheInfo;
